import React, { useEffect, useRef } from "react";
import connect from "Shared/connect";
import { translate } from "Shared/translate";
import { closeMainMenu, toggleMainMenu, } from "../../../MainMenu/action-creators";
import * as styles from "../../../MainMenu/DesktopMenu/CategoryDropdown/CategoryDropdown.scss";
import Icon from "Shared/Icon";
import { LARGE } from "Shared/breakpoints";
const CategoryDropdown = (props) => {
    const ref = useRef(null);
    const handleClickOutside = (e) => {
        props.closeMainMenu();
    };
    useEffect(() => {
        const listener = (event) => {
            const el = ref.current;
            if (!el || el.contains(event.target)) {
                return;
            }
            handleClickOutside(event);
        };
        if (props.currentBreakpoint < LARGE) {
            props.closeMainMenu();
        }
        document.addEventListener("click", listener);
        return () => {
            document.removeEventListener("click", listener);
        };
    }, [ref, props.currentBreakpoint, props.isOpen]);
    return (React.createElement("div", { ref: ref, className: styles.dropdownWrapper, onClick: () => props.toggleMainMenu() },
        React.createElement("div", { className: styles.dropdownContent },
            translate("/Sitelayout/Header/CategoryDropdowntext"),
            !props.isOpen ? (React.createElement(Icon, { name: "header-category-dropdown" })) : (React.createElement(Icon, { name: "header-category-dropdown-up" })))));
};
export default connect((state) => ({
    isOpen: state.mainMenu.isOpen,
    currentBreakpoint: state.currentBreakpoint,
}), (dispatch) => ({
    toggleMainMenu: () => dispatch(toggleMainMenu()),
    closeMainMenu: () => dispatch(closeMainMenu()),
}))(CategoryDropdown);
